export default "__VITE_ASSET__DfxXbjws__"